import PitchLayout from './PitchLayout';
import PremiumLayout from './PremiumLayout';
import OnepagerLayout from './OnepagerLayout';
import AppleLayout from './AppleLayout';
import NotionLayout from './NotionLayout';
import LinearLayout from './LinearLayout';
import StripeLayout from './StripeLayout';
import SwissLayout from './SwissLayout';
import BrutalistLayout from './BrutalistLayout';

// Registry: Layout-ID → Komponente.
// 'document' ist NICHT hier registriert — dafür rendert PublicQuoteView sein
// eingebautes (unverändertes) Dokument-Layout. null = Dokument-Fallback.
export const LAYOUT_COMPONENTS = {
  pitch: PitchLayout,
  premium: PremiumLayout,
  onepager: OnepagerLayout,
  apple: AppleLayout,
  notion: NotionLayout,
  linear: LinearLayout,
  stripe: StripeLayout,
  swiss: SwissLayout,
  brutalist: BrutalistLayout,
};

export const getLayoutComponent = (layoutId) => LAYOUT_COMPONENTS[layoutId] || null;
